
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profiles/[userId]/[[...params]]",
      function () {
        return require("private-next-pages/profiles/[userId]/[[...params]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profiles/[userId]/[[...params]]"])
      });
    }
  